var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdeen16X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.32227,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white",
    stroke: "#344054"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89001 4.39541C6.89001 4.92944 6.42713 5.36235 5.85614 5.36235C5.28515 5.36235 4.82227 4.92944 4.82227 4.39541C4.82227 3.86138 5.28515 3.42847 5.85614 3.42847C6.42713 3.42847 6.89001 3.86138 6.89001 4.39541Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96365 6.0731H6.73095V11.4285H4.96365V6.0731Z",
    fill: "#344054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57632 6.0731H7.80901V11.4285H9.57632C9.57632 11.4285 9.57632 9.74252 9.57632 8.68839C9.57632 8.05568 9.79236 7.4202 10.6544 7.4202C11.6286 7.4202 11.6227 8.2482 11.6182 8.88966C11.6122 9.72815 11.6264 10.5838 11.6264 11.4285H13.3937V8.60202C13.3787 6.79725 12.9084 5.96566 11.3613 5.96566C10.4425 5.96566 9.87296 6.38279 9.57632 6.76018V6.0731Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdeen16X);
export default __webpack_public_path__ + "static/media/linkdeen-16x.97e409ebdcd9b32db1ac138b3f673324.svg";
export { ForwardRef as ReactComponent };